module.exports = __webpack_public_path__ + "img/champion-floating-en.49f5446f.gif";